import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=79fdd2d0&scoped=true&"
import script from "./GoTop.vue?vue&type=script&lang=js&"
export * from "./GoTop.vue?vue&type=script&lang=js&"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=79fdd2d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fdd2d0",
  null
  
)

export default component.exports